import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=5354050c&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=ts"
export * from "./BookingForm.vue?vue&type=script&lang=ts"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=5354050c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354050c",
  null
  
)

export default component.exports